module.exports = __webpack_public_path__ + "static/media/big-overlay.4e4915b7.png";